export const blockIconsSearchDoorSliding = (
	<span className='material-symbols-outlined'>door_sliding</span>
);
